import {
  getFastestSla,
  getCheapestSla,
  isPickupSlaType,
  isDeliverySlaType,
} from '@/checkout-instore-legacy/shipping/utils'
import { getIntlMessage } from '@/checkout-instore-legacy/i18n/utils'
import isEmpty from 'lodash/isEmpty'

export const toDeliveryItem = (sla, intlIdMessage) => ({
  id: sla?.id,
  store: {
    iconType: 'nc-delivery',
    name: getIntlMessage(intlIdMessage),
  },
  shippingEstimate: sla && sla.shippingEstimate ? sla.shippingEstimate : null,
  shippingCost: sla && sla.price ? sla.price : null,
})

export const toPickUpItem = (sla) => ({
  id: sla?.id,
  store: {
    iconType: 'nc-store',
    name: sla.pickupStoreInfo ? sla.pickupStoreInfo.friendlyName : sla.name,
  },
  shippingEstimate: sla && sla.shippingEstimate ? sla.shippingEstimate : null,
  shippingCost: sla && sla.price ? sla.price : null,
})

export const extractItemsForPickupPoint = (slas) => {
  const pickupPointSLAS = slas.filter(({ deliveryChannel }) =>
    isPickupSlaType(deliveryChannel)
  )
  return pickupPointSLAS.map(toPickUpItem)
}

export const extractItemsForDelivery = (slas) => {
  const deliveryItems = []

  if (isEmpty(slas)) {
    return deliveryItems
  }

  const deliverySLAs = slas.filter(({ deliveryChannel }) =>
    isDeliverySlaType(deliveryChannel)
  )

  const fastSLA = getFastestSla(deliverySLAs)
  const cheapSLA = getCheapestSla(deliverySLAs)
  if (fastSLA) {
    if (fastSLA === cheapSLA) {
      const deliverySLA = toDeliveryItem(
        fastSLA,
        'product.shippingAid.delivery'
      )
      deliveryItems.push(deliverySLA)
    } else {
      const fastDeliverySLA = toDeliveryItem(
        fastSLA,
        'product.shippingAid.delivery.fast'
      )
      deliveryItems.push(fastDeliverySLA)

      const cheapDeliverySLA = toDeliveryItem(
        cheapSLA,
        'product.shippingAid.delivery.cheap'
      )
      deliveryItems.push(cheapDeliverySLA)
    }
  }

  return deliveryItems
}
